<div class="notifier">
    <div class="notifier-message" [innerHTML]="message"></div>
    <div class="notifier-action" (click)="action()">{{actionLabel}}</div>
</div>